module.exports = __webpack_public_path__ + "static/media/expand_content.aa2c7b3d.svg";